import { ErrorMessage, Formik } from "formik";
import { useEffect, useState } from "react";
import { Col, Form, Input, Label, Row } from "reactstrap";
import Select from "react-select";
import TextError from "../../FormikError/TextError";
import CustomButton from "../../CustomElements/FormElements/CustomButton";
import {
  AddTransferInitialValues,
  TransferValidationSchema,
} from "../../../Pages/Private/MemberModule/TransferRequest/AddTransferRequest/AddTransferRequestMethods/FormikValidation";
import {
  addModalInitialValuesHandler,
  directOfficeChangeSubmitHandler,
} from "./DirectOfficeChangeModalMethods";
import {
  getBlock,
  getDistrict,
  transferGetDesignation,
  transferGetOffice,
  getCadreFullList,
} from "../../../Api/AdminApis";
import { useQuery } from "react-query";
import { TRANSIT_TYPE } from "../../../Utils/Constants/selection_options";
import { api } from "../../../Api/Api";

const DirectOfficeChangeModal = ({
  setModal,
  memberData,
  Refetch,
}: any) => {
  const [addModalInitialValues, setAddModalInitialValues] = useState(
    AddTransferInitialValues
  );
  // const [editMode, setEditMode] = useState<boolean>(false);
  const [seatAvailability, setSeatAvailability] = useState<any>(null);

  

  useEffect(() => {
    // Initialize with current member data
    if (memberData) {
      setAddModalInitialValues({
        ...AddTransferInitialValues,
        office: memberData?.office_name || "",
        office_id: memberData?.office_id || "",
        district: memberData?.district_id || "",
        block: memberData?.block_id || "",
      });
      setValue({
        district: memberData?.district_id || "",
        block: memberData?.block_id || "",
        office: memberData?.office_id || "",
      });
    }
  }, [memberData]);

  const [value, setValue] = useState({
    district: "",
    block: "",
    office: "",
  });

  const {
    data: districtList,
  }: any = useQuery([`district`], () => getDistrict(), {
    keepPreviousData: true,
  });

  const {
    data: designationListForTransfer,
  }: any = useQuery(
    [`designation`, value?.district],
    () => (value?.district ? transferGetDesignation(value?.district) : ""),
    {
      keepPreviousData: true,
    }
  );

  const {
    data: cadreList,
  }: any = useQuery([`cadre`], () => getCadreFullList(), {
    keepPreviousData: true,
  });

  const {
    data: blockList,
  }: any = useQuery(
    [`block${value?.district}`, value?.district],
    () => (value?.district ? getBlock(value?.district) : ""),
    {
      keepPreviousData: true,
    }
  );

  const { data: OfficeList }: any = useQuery(
    [
      `transferOffice${value?.district}${value?.block}`,
      value?.district,
      value?.block,
    ],
    () =>
      value?.district && value?.block
        ? transferGetOffice(value?.district, value?.block)
        : "",
    {
      keepPreviousData: true,
      onSuccess: (data) => {
        // Find selected office and show seat availability
        if (addModalInitialValues?.to_office && data) {
          const selectedOffice = data.find(
            (office: any) => office.value === addModalInitialValues?.to_office
          );
          if (selectedOffice) {
            setSeatAvailability({
              available: selectedOffice.available_seats || 0,
              total: selectedOffice.total_seat_count || 0,
              occupied: selectedOffice.occupied_seat_count || 0,
            });
          }
        }
      },
    }
  );

  return (
    <Formik
      validationSchema={TransferValidationSchema}
      initialValues={addModalInitialValues}
      enableReinitialize
      onSubmit={(values, actions) => {
        directOfficeChangeSubmitHandler(
          values,
          actions,
          setModal,
          Refetch,
          memberData
        );
      }}
    >
      {({
        handleSubmit,
        handleChange,
        isSubmitting,
        values,
        setFieldValue,
        errors,
      }) => {
        return (
          <div className="form-wrap">
            <Form onSubmit={handleSubmit}>
              <Row className="gy-4">
                <Col md={12}>
                  <Label>Current Office</Label>
                  <Input
                    type="text"
                    name="current_office"
                    value={memberData?.office_name || ""}
                    disabled
                  />
                </Col>
                <p>Transfer To</p>
                <Col md={6}>
                  <Label>District</Label>
                  <Select
                    placeholder="Select District"
                    name="district"
                    options={districtList ? districtList : []}
                    value={
                      districtList
                        ? districtList?.filter(
                            (itm: any) => itm?.value === values?.district
                          )
                        : ""
                    }
                    onChange={(e: any) => {
                      setFieldValue("district", e?.value);
                      setValue({
                        ...value,
                        district: e?.value,
                        block: "",
                        office: "",
                      });
                      setFieldValue("block", "");
                      setFieldValue("to_office", "");
                    }}
                    isLoading={false}
                    loadingMessage={() => "Fetching District"}
                    noOptionsMessage={() => "District appears here"}
                    isSearchable={true}
                    isClearable
                  />
                  <ErrorMessage name="district" component={TextError} />
                </Col>

                <Col md={6}>
                  <Label>Block</Label>
                  <Select
                    placeholder="Select Block"
                    name="block"
                    options={blockList ? blockList : []}
                    value={
                      blockList
                        ? blockList?.filter(
                            (itm: any) => itm?.value === values?.block
                          )
                        : ""
                    }
                    onChange={(e: any) => {
                      setFieldValue("block", e?.value);
                      setValue({
                        ...value,
                        block: e?.value,
                        office: "",
                      });
                      setFieldValue("to_office", "");
                    }}
                    isLoading={false}
                    loadingMessage={() => "Fetching Block"}
                    noOptionsMessage={() => "Block appears here"}
                    isSearchable={true}
                    isClearable
                    isDisabled={!values?.district}
                  />
                  <ErrorMessage name="block" component={TextError} />
                </Col>

                <Col md={6}>
                  <Label>Office</Label>
                  <Select
                    placeholder="Select Office"
                    name="to_office"
                    options={OfficeList ? OfficeList : []}
                    value={
                      OfficeList
                        ? OfficeList?.filter(
                            (item: any) => item.value === values?.to_office
                          )
                        : null
                    }
                    onChange={(e: any) => {
                      setFieldValue("to_office", e?.value);
                    }}
                    isLoading={false}
                    loadingMessage={() => "Fetching Office"}
                    noOptionsMessage={() => "Office appears here"}
                    isSearchable={true}
                    isClearable={true}
                    isDisabled={!values?.block}
                  />
                  <ErrorMessage name="to_office" component={TextError} />
                </Col>

                {values?.to_office && seatAvailability && (
  <Col md={12}>
    <div className="seat-availability-info">
      <Label>Seat Availability</Label>
      <div className="seat-info">
        <span>Total Seats: {seatAvailability.total}</span>
        <span>Occupied: {seatAvailability.occupied}</span>
        <span className={seatAvailability.available > 0 ? "text-success" : "text-danger"}>
          Available: {seatAvailability.available}
        </span>
      </div>
      {seatAvailability.available <= 0 && (
        <div className="alert alert-warning mt-2">
          No available seats in this office. Please select another office.
        </div>
      )}
    </div>
  </Col>
)}

                <Col md={6}>
                  <Label>Transfer Type</Label>
                  <Select
                    placeholder="Select Transfer Type"
                    name="type"
                    options={TRANSIT_TYPE ? TRANSIT_TYPE : []}
                    value={
                      TRANSIT_TYPE
                        ? TRANSIT_TYPE?.filter(
                            (itm: any) => itm?.value === values?.type
                          )
                        : ""
                    }
                    onChange={(e: any) => {
                      setFieldValue("type", e?.value);
                    }}
                    isLoading={false}
                    loadingMessage={() => "Fetching Transfer Type"}
                    noOptionsMessage={() => "Transfer Type appears here"}
                    isSearchable={true}
                    isClearable={true}
                  />
                  <ErrorMessage name="type" component={TextError} />
                </Col>

                {Number(values?.type) === 2 && (
                  <>
                  <Col md={6}>
                      <Label>Cadre</Label>
                      <Select
                        placeholder="Select Cadre"
                        name="cadre"
                        options={cadreList ? cadreList : []}
                        value={
                          cadreList
                            ? cadreList?.filter(
                                (itm: any) => itm?.value === values?.cadre
                              )
                            : ""
                        }
                        onChange={(e: any) => {
                          setFieldValue("cadre", e?.value);
                        }}
                        isLoading={false}
                        loadingMessage={() => "Fetching Cadre"}
                        noOptionsMessage={() => "Cadre appears here"}
                        isSearchable={true}
                        isClearable={true}
                      />
                      <ErrorMessage name="cadre" component={TextError} />
                    </Col>
                  
                    <Col md={6}>
                      <Label>Designation</Label>
                      <Select
                        placeholder="Select Designation"
                        name="designation"
                        options={
                          designationListForTransfer
                            ? designationListForTransfer
                            : []
                        }
                        value={
                          designationListForTransfer
                            ? designationListForTransfer?.filter(
                                (itm: any) => itm?.value === values?.designation
                              )
                            : ""
                        }
                        onChange={(e: any) => {
                          setFieldValue("designation", e?.value);
                        }}
                        isLoading={false}
                        loadingMessage={() => "Fetching Designation"}
                        noOptionsMessage={() => "Designation appears here"}
                        isSearchable={true}
                        isClearable={true}
                      />
                      <ErrorMessage name="designation" component={TextError} />
                    </Col>
                    </>
                )}

                <Col md={6}>
                  <Label>GO Order</Label>
                  <Input
                    type="text"
                    onChange={handleChange}
                    value={values?.GO_order}
                    name="GO_order"
                    placeholder="GO Order"
                  />
                  <ErrorMessage name="GO_order" component={TextError} />
                </Col>

                <Col md={6}>
                  <Label>GO Date</Label>
                  <Input
                    type="date"
                    onChange={handleChange}
                    value={values?.GO_order_date}
                    name="GO_order_date"
                  />
                  <ErrorMessage name="GO_order_date" component={TextError} />
                </Col>

                <Col lg={12}>
                  <CustomButton
                    isLoading={isSubmitting}
                    label="Submit"
                    color="primary"
                    className="sm submit-btn"
                  />
                </Col>
              </Row>
            </Form>
          </div>
        );
      }}
    </Formik>
  );
};

export default DirectOfficeChangeModal;